import axios from "axios";
import { CirclePlay, Loader } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router";

import { GenericException } from "base/ui/errors";
import { CountryPhoneCodeSelect } from "base/ui/misc";
import { openWhatsapp, useRerender } from "base/utils/common";

import logo from "./images/ic_flowcart_logo_dark.svg?url";
import bgPage1 from "./images/landing/page1_bg.svg?url";
import IMG_SUCCESS from "./images/onboarding/ic_success.svg?url";
import WhatsAppIcon from "./images/whatsapp.svg?url";

const _details = [
	{
		heading: "24X7 Shopper Assistance",
		desc: `Answers fast & Accurate. Converts Chats to Orders.`,
		points: [
			{
				desc: "Handles product, delivery, return & store FAQs instantly.",
			},
			{
				desc: "Shares the right links/products inside chat.",
			},
			{
				desc: "Escalates to a human when needed.",
			},
		],
		img: "https://storage.googleapis.com/sukhiba/mobilefresh/user_uploads/2025-09-08/17573348761y10bshw6k__Group_1707488174.webp",
    video_src: "https://youtu.be/ESVXl5MHkxo?si=PHsZ-LAO6nwWCs36",
	},
	{
		heading: "Personalised Shopping Specialist",
		desc: `Gets you more conversions with personal product recommendations.`,
		points: [
			{
				desc: "Recommends products using customer queries.",
			},
			{
				desc: "Cross-sells & Upsells based on their purchase history.",
			},
			{
				desc: "Asks needs & budget to recommend best-fit items.",
			},
		],
		img: "https://storage.googleapis.com/sukhiba/mobilefresh/user_uploads/2025-09-08/17573348766jSZ0ru7Jg__Group_1707488175.webp",
    video_src: "https://youtu.be/ESVXl5MHkxo?si=PHsZ-LAO6nwWCs36",
	},
	{
		heading: "In-Chat Shopping",
		desc: `Convert Chats to Carts and Carts to Payments. Seamlessly.`,
		points: [
			{
				desc: "WhatsApp catalogues with variants, price & stock.",
			},
			{
				desc: "Add to cart and payments right inside WhatsApp.",
			},
			{
				desc: "Integrates with all major payment providers.",
			},
		],
		img: "https://storage.googleapis.com/sukhiba/mobilefresh/user_uploads/2025-09-08/1757334876CH9ljSGAiW__Group_1707486584_1.webp",
    video_src: "https://youtu.be/ESVXl5MHkxo?si=PHsZ-LAO6nwWCs36",
	},
];

const promo_data = [
	{
		video_src: "https://youtu.be/ESVXl5MHkxo?si=PHsZ-LAO6nwWCs36",
		title: "Gamification by Flowcart",
		description:
			"Add/upload your Customers and interact with them.Upload existing customer list or create customers manually and Chat.",
		buttonText: "Try on WhatsApp",
	},
	{
		video_src: "https://youtu.be/ESVXl5MHkxo?si=PHsZ-LAO6nwWCs36",
		title: "Abandoned Cart Flow",
		description:
			"If you have existing customer list you can upload it or create customers manually and Chat with them.",
		buttonText: "Try on WhatsApp",
	},
	{
		video_src: "https://youtu.be/ESVXl5MHkxo?si=PHsZ-LAO6nwWCs36",
		title: "Post Order Message",
		description:
			"Add/upload your Customers and interact with them.Upload existing customer list or create customers manually and Chat.",
		buttonText: "Try on WhatsApp",
	},
	{
		video_src: "https://youtu.be/ESVXl5MHkxo?si=PHsZ-LAO6nwWCs36",
		title: "Click to Whatsapp Flow",
		description:
			"Add/upload your Customers and interact with them.Upload existing customer list or create customers manually and Chat.",
		buttonText: "Try on WhatsApp",
	},
];

const success_promo_data = [
	// {
	// 	title: "Smart AI FAQ Bot",
	// 	description:
	// 		"Load your knowledge base once and Flowcart does the talking 24 X 7. Answers questions, shares catalogues, and closing sales even while you're asleep.",
	// 	tutorial_link: "https://youtu.be/ESVXl5MHkxo?si=PHsZ-LAO6nwWCs36",
	// },
	{
		title: "Product Recommendation Bot",
		description:
			"Gets you more conversions with personal product recommendations.",
		tutorial_link: "https://youtu.be/ESVXl5MHkxo?si=PHsZ-LAO6nwWCs36",
		whatsapp_msg: "Hi, i am looking for a product"
	},
	{
		title: "Experience WhatsApp Shopping",
		description:
			"Convert Chats to Carts and Carts to Payments. Seamlessly.",
		tutorial_link: "https://youtu.be/ESVXl5MHkxo?si=PHsZ-LAO6nwWCs36",
		whatsapp_msg: "shop"
	},
];

const PromoCard = ({ video_src, title, description, handleClick, tutorial_link }) => {
	return (
		<div className="tw-w-[280px] tw-rounded-xl tw-overflow-hidden tw-border tw-shadow-sm tw-bg-white">
			<div className="tw-relative">
				{video_src && <video src={video_src} className="tw-w-full tw-h-48 tw-object-cover" controls={true} />}
			</div>

			<div className="tw-p-4">
				<div className="tw-flex tw-flex-col tw-gap-2 tw-text-center">
					<h3 className="tw-text-[16px] tw-font-bold">{title}</h3>
					<p className="tw-text-[#666666] tw-text-xs tw-font-normal">{description}</p>
				</div>
				<button
					onClick={handleClick}
					className="tw-my-4 btn-primary-v2 tw-py-3 tw-flex tw-gap-1 tw-items-center hover:tw-flex tw-px-8 tw-justify-center tw-w-full"
					type="button"
				>
					<img src={WhatsAppIcon} width={18} className="tw-mr-[2px]" alt="whatsapp_icon" />
					Try on WhatsApp
				</button>
				{/* {tutorial_link ? (
					<p
						className=" tw-text-[#005BD3] tw-flex tw-gap-1 tw-items-center tw-justify-center tw-w-full tw-text-sm tw-cursor-pointer"
						type="button"
            onClick={() => {
              Popup.open("How it Works",
              <div className="tw-relative">
              {tutorial_link && <video src={tutorial_link} className="tw-w-full tw-h-full tw-object-cover" controls={true} />}
            </div>)
            }}
					>
						<CirclePlay className="" size={13} />
						How it works
					</p>
				) : null} */}
			</div>
		</div>
	);
};

const WebScrappingPage = () => {
	const inputRef = useRef(null);
	const ctx = useRef({ url: "", country_phone_code: "", phone_number: ""}).current;
	const [error, setError] = useState({});
	const [status, setStatus] = useState("idle"); // idle | loading | success
	const [org_phonenumber, setOrgPhoneNumber] = useState();
	const rerender = useRerender();

	const handleScrollToInput = () => {
		inputRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
		inputRef.current?.focus();
	};

	const handleFetchContent = async () => {
		let errors = {};
		if (!ctx.url || !ctx.url.trim()) {
			errors.url = "Please enter a website link";
		}
		if (!ctx.phone_number || !ctx?.phone_number.trim()) {
			errors.phone_number = "Please enter a whatsapp number";
		}

		if (Object.keys(errors).length > 0) {
			setError(errors);
			return;
		}

		if(status === "loading") return

		setError({});

		try {
			setStatus("loading");
	
			const resp = await axios.post(`/api/public_page`, {
				...ctx,
			});
	
			if (resp.data.errors) {
				setStatus("idle");
				GenericException.showPopup(resp.data.errors);
				return;
			}
	
			if (resp.data.shop_creation) {
				setStatus("success");
				setOrgPhoneNumber(resp.data.business_wa_number)
			}
		} catch (err) {
			setStatus("idle");
			setError({
				message: "Something went wrong. Try again."
			});
		}
	};

	const handleReset = () => {
		ctx.url = "";
		ctx.phone_number = "";
		setError({});
		setStatus("idle");
		if (inputRef.current) inputRef.current.focus();
	};

	useEffect(() => {
		axios.get("/user/location").then(
			(resp) => {
				if (resp.data) {                    
					ctx.country_phone_code = resp.data.phone_code;
					rerender();
				}
			}
		)
	}, [])

	const handleOpenWhatsApp = (msg) => {
		if(org_phonenumber) {
			openWhatsapp(org_phonenumber, msg)
		}
	}

	return (
		<>
			<div
				className="font-figtree tw-scroll-smooth tw-scrollbar-none"
				style={{ backgroundImage: `url("${bgPage1}")`, backgroundSize: "cover", minWidth: "100%", minHeight: "100%" }}
			>
				<div
					style={{ backgroundImage: `url("${bgPage1}")`, backgroundSize: "cover" }}
					className="tw-sticky tw-top-0 tw-flex tw-px-8 tw-py-6 lg:tw-px-16 tw-text-black tw-justify-between tw-items-center tw-z-[4]"
				>
					<Link to="/">
						<div className="tw-cursor-pointer">
							<img src={logo} className="tw-h-[33px]" alt="flowcart_logo" />
						</div>
					</Link>
				</div>
				<div
					id="home"
					className={`tw-relative tw-px-6  sm:tw-flex md:tw-justify-center max-lg:tw-gap-8 lg:tw-gap-16 ${status === "success" ? "tw-mb-0 tw-pt-6 ": "tw-mb-16 tw-py-6 "}`}
				>
					<div className="tw-text-center">
						<div className="tw-text-[58px] lg:tw-text-[48px] xl:tw-text-[60px] tw-leading-tight tw-font-bold">
							<p className="">Experience AI Powered Selling</p>
							<p className="tw-text-landing-green">on WhatsApp!</p>
						</div>
						<div className="sm:tw-whitespace-pre tw-mt-6 tw-font-[500] tw-text-[15px] md:tw-text-[15px]  sm:tw-text-[18px] lg:tw-text-[24px] tw-text-[#615F5C]">
							Enter your Website URL to experience Flowcart&apos;s AI on WhatsApp.
						</div>
						<div className="tw-mt-7">
							{status === "idle" && (
								<div className="tw-flex tw-gap-5 tw-items-start max-md:tw-flex-wrap tw-flex-col">
									<div className="tw-flex tw-flex-row tw-w-full tw-gap-4 tw-flex-wrap">
										<div className="tw-w-full tw-flex-1">
											<div className='tw-border tw-flex tw-w-full input-primary !tw-py-2.5 !tw-px-4 tw-rounded-lg'>
												<CountryPhoneCodeSelect
													onChange={(country_phone_code) => {
														ctx.country_phone_code = country_phone_code;
														rerender();
													}}
													default_phone_code={`+${ctx?.country_phone_code}`}
												/>
												<input type='number' className='tw-flex-1 tw-outline-0  tw-border-l tw-pl-4 tw-appearance-none'
													placeholder='Enter WhatsApp Number'
													defaultValue={ctx?.phone_number}
													onChange={(e) => {
														ctx.phone_number = e.target.value;
														rerender();
													}}
                      />
											</div>
											{error?.phone_number && (
												<p className="tw-text-[#E10000] tw-text-sm tw-mt-1 tw-font-semibold tw-text-start">{error?.phone_number}</p>
											)}
                    </div>
										<div className="tw-w-full tw-flex-1">
											<input
												className={`input-primary !tw-py-4 !tw-px-4 tw-rounded-lg ${
													error?.url ? "tw-bg-[#FFF0F0] tw-border-[#E10000]" : ""
												}`}
												placeholder="Enter your website link"
												ref={inputRef}
												value={ctx?.url}
												onChange={(e) => {
													ctx.url = e.target.value;
													rerender();
												}}
											/>
											<div className="tw-mt-1 tw-flex tw-justify-between">
												{error?.url && (
													<p className="tw-text-[#E10000] tw-text-sm tw-font-semibold tw-text-start tw-flex-1 tw-w-1/2 tw-break-all">{error?.url}</p>
												)}
												<p className="tw-text-gray-500 tw-text-xs tw-font-semibold tw-text-end tw-flex-1 tw-w-1/2">* Shopify and Woo-commerce Websites</p>
											</div>
										</div>
									</div>
									{error?.message && (
										<p className="tw-text-[#E10000] tw-text-sm tw-font-semibold tw-text-start">{error?.message}</p>
									)}
									<div className="tw-flex tw-justify-center tw-w-full">
										<button
											className="btn-primary-v2 tw-py-4 tw-text-[18px] "
											type="button"
											onClick={(e) => handleFetchContent(e)}
										>
											Generate my WhatsApp store!
										</button>
									</div>
								</div>
							)}
							{status === "loading" && (
								<div className="tw-flex tw-justify-center tw-items-center tw-py-6 tw-flex-col">
									<Loader size={36} className="tw-animate-custom-spin" />
									<p className="tw-mt-3 tw-text-sm tw-font-[500]">We are fetching content and upto 30 only products </p>
								</div>
							)}
							{status === "success" && (
								<div className="tw-flex tw-flex-col tw-items-center tw-gap-3 tw-py-6">
									<img src={IMG_SUCCESS} alt="img_success" width={64} height={55} />
									<div>
										<p className="tw-text-sm tw-font-[500]">Now you can test the features below for {ctx?.url}</p>
										<button className="tw-text-sm tw-text-primary-v2 tw-font-bold" onClick={handleReset} type="button">
											RESET
										</button>
									</div>
								</div>
							)}
						</div>
					</div>
				</div>
				<div className={`tw-rounded-xl tw-flex tw-justify-center tw-items-center tw-relative tw-px-6 ${status === "success" ? "tw-mt-0": "tw-mt-12"}`}>
					{status !== "success" 
            ? (
              <>
                <div
                  className="tw-absolute -tw-top-12 tw-left-0 tw-right-0 tw-h-11 tw-blur-2xl"
                  style={{
                    background: `radial-gradient(ellipse 1000px 120px at center, #FAD274, #fdf2d9 40%, transparent 70%)`,
                  }}
                />
                <LazyLoadImage
                  src="https://storage.googleapis.com/sukhiba/mobilefresh/user_uploads/2025-08-12/1754976887TynS3BDDfI__Dashboard_638.png"
                  className=""
                />
              </>
            ) 
            : (
              <div className="tw-flex tw-flex-wrap tw-gap-4 tw-justify-center tw-mt-8">
                {success_promo_data.map((item, index) => (
                  <PromoCard key={index} {...item} handleClick={() => handleOpenWhatsApp(item.whatsapp_msg)} />
                ))}
              </div>
            )
          }
				</div>
			</div>
			<div className="">
				{_details.map((item, index) => (
					<div
						key={index}
						className={`tw-py-14 tw-grid tw-justify-center ${index % 2 === 0 ? "tw-bg-[#FBF6EF]" : "tw-bg-[#FEFDFB]"} tw-px-6`}
					>
						<div
							className={`tw-mt-8 tw-flex max-lg:tw-grid max-lg:tw-justify-items-center tw-items-center tw-text-landing-black tw-justify-center xl:tw-gap-20 max-md:tw-flex-wrap ${index % 2 === 1 ? "tw-flex-row-reverse" : ""} max-md:tw-flex-col-reverse md:tw-gap-12 max-lg:tw-mb-6`}
						>
							<div className="tw-flex-initial lg:tw-w-[550px] max-lg:tw-w-full tw-text-left">
								<div className="tw-text-[28px] md:tw-text-[38px] tw-font-bold">{item.heading}</div>
								<div
									className="tw-text-[16px] md:tw-text-[22px] tw-font-light tw-text-landing-black tw-mt-4"
									dangerouslySetInnerHTML={{ __html: item.desc }}
								/>
								{item.points.map((point, i) => {
									return (
										<div key={i} className="tw-text-[#FFA800] tw-mt-6">
											<div>
												<div className="tw-mt-2 tw-text-[15px] md:tw-text-[18px] !tw-font-light tw-text-[#666666] tw-flex tw-gap-2 tw-items-start">
													<p className="tw-w-2 tw-h-2 tw-bg-primary-v2 tw-rounded-full tw-mt-2" />
													{point.desc}
												</div>
											</div>
										</div>
									);
								})}
								<div className="tw-flex tw-gap-4 tw-mt-8">
									<button
										className="btn-primary-v2 tw-py-3 tw-flex tw-gap-1 tw-items-center hover:tw-flex tw-px-8"
										type="button"
										onClick={handleScrollToInput}
									>
										<img src={WhatsAppIcon} width={18} className="tw-mr-[2px]" alt="whatsapp_icon" />
										Try on WhatsApp
									</button>
									{/* <button
										className="btn-secondary tw-border-[#005BD3] tw-text-[#005BD3] tw-py-3 tw-flex tw-gap-1 tw-items-center tw-px-5"
										type="button"
                    onClick={() => {
                      Popup.open("How it Works",
                      <div className="tw-relative">
                      {<video src={item.video_src} className="tw-w-full tw-h-full tw-object-cover" controls={true} />}
                    </div>)
                    }}
									>
										<CirclePlay className="" size={13} />
										How it works
									</button> */}
								</div>
							</div>
							<div className="lg:tw-w-[500px]">
								<img src={item.img} className="max-md:tw-mt-6 " alt="item_img" />
							</div>
						</div>
					</div>
				))}
			</div>
			{/* <div className="tw-bg-[#FEFDFB] tw-py-14">
				<p className="tw-text-[24px] tw-font-bold tw-text-primary-v2 tw-text-center">Feature Highlights</p>
				<p className="tw-text-[28px] md:tw-text-[34px] tw-font-bold tw-text-primary-text tw-text-center tw-mt-2">
					That’s not all ! we have much to offer
				</p>
				<div className="tw-flex tw-flex-wrap tw-gap-4 tw-justify-center tw-mt-8">
					{promo_data.map((item, index) => (
						<PromoCard key={index} {...item} handleClick={handleScrollToInput} />
					))}
				</div>
			</div> */}
		</>
	);
};

export default WebScrappingPage;
